// src/components/ChatBot.js
import React, { useState } from "react";
import {
  Box,
  IconButton,
  TextField,
  Typography,
  Paper,
  Divider,
} from "@mui/material";
import ChatIcon from "@mui/icons-material/Chat";
import SendIcon from "@mui/icons-material/Send";

function ChatBot() {
  const [open, setOpen] = useState(false);
  const [messages, setMessages] = useState([
    { from: "bot", text: "Hello 👋 I'm Arocoiris Assistant. How can I help you today?" },
  ]);
  const [input, setInput] = useState("");

  const handleSend = () => {
    if (!input.trim()) return;
    setMessages([...messages, { from: "user", text: input }]);
    setInput("");

    // For now, just echo a generic response
    setTimeout(() => {
      setMessages((prev) => [
        ...prev,
        { from: "bot", text: "Thanks for your question! Our team will get back to you soon." },
      ]);
    }, 500);
  };

  return (
    <>
      {/* Floating chat button */}
      <IconButton
        onClick={() => setOpen(!open)}
        sx={{
          position: "fixed",
          bottom: 20,
          right: 20,
          backgroundColor: "#00C853",
          color: "white",
          "&:hover": { backgroundColor: "#009624" },
        }}
      >
        <ChatIcon />
      </IconButton>

      {/* Chat window */}
      {open && (
        <Paper
          elevation={6}
          sx={{
            position: "fixed",
            bottom: 80,
            right: 20,
            width: 300,
            height: 400,
            display: "flex",
            flexDirection: "column",
          }}
        >
          <Box sx={{ p: 2, backgroundColor: "#0A192F", color: "white" }}>
            <Typography variant="h6">Arocoiris Assistant</Typography>
          </Box>
          <Divider />
          <Box sx={{ flex: 1, p: 2, overflowY: "auto" }}>
            {messages.map((msg, i) => (
              <Box
                key={i}
                sx={{
                  textAlign: msg.from === "user" ? "right" : "left",
                  mb: 1,
                }}
              >
                <Typography
                  variant="body2"
                  sx={{
                    display: "inline-block",
                    p: 1,
                    borderRadius: 2,
                    backgroundColor:
                      msg.from === "user" ? "#00C853" : "#f1f1f1",
                    color: msg.from === "user" ? "white" : "black",
                  }}
                >
                  {msg.text}
                </Typography>
              </Box>
            ))}
          </Box>
          <Divider />
          <Box sx={{ display: "flex", p: 1 }}>
            <TextField
              size="small"
              fullWidth
              placeholder="Type your question..."
              value={input}
              onChange={(e) => setInput(e.target.value)}
            />
            <IconButton color="primary" onClick={handleSend}>
              <SendIcon />
            </IconButton>
          </Box>
        </Paper>
      )}
    </>
  );
}

export default ChatBot;